<template>
  <div class="animated fadeIn" >
    <b-card>
      <div slot="header" v-if="!add && lock">
        Profile
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify Profile
      </div>

      <b-row>
        <b-col v-show="lock">
          <b-form-group>
            <label class="text-primary" for="ph_permission">Permission</label>
            <b-input type="text" v-model="model.permission" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-show="lock">
          <b-form-group>
            <label class="text-primary" for="ph_last_login">Last Login</label>
            <b-input type="text" v-bind:value="model.last_login | datetime" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label class="text-primary" for="ph_username">ID</label>
            <b-input type="text" v-model="model.username" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label class="text-primary" for="ph_nickname">Name</label>
            <b-input type="text" v-model="model.name" :plaintext="lock" placeholder="Name"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col>
          <b-form-group>
            <label class="text-primary" for="ph_pass">Password</label>
            <b-input type="password" v-model="pass.old" :plaintext="lock" placeholder="Password"></b-input>
            <label class="mt-2 ml-1" v-if="!add">* 변경시에만 입력하세요.</label>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col>
          <b-form-group>
            <label class="text-primary" for="ph_pass">Confirm Password</label>
            <b-input type="password" v-model="pass.new" :plaintext="lock" placeholder="Confirm Password"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-if="lock">
        <template>
          <div class="float-right">
          <b-button size="sm" variant="primary" @click="edit"> Modify </b-button>
          </div>
        </template>
      </template>
      <template v-else>
      <div class="float-right">
        <b-button class= "mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
        <b-button size="sm" variant="primary" @click="save"> Save </b-button>
      </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { api, auth } from '@/f1/service';

import * as forge from 'node-forge'
import reg from '@/f1/reg'

export default {
  data : () => ({
    confirm: false, add: false, lock: true, group_list: undefined,
    model : { },
    pass : { },
  }),
  methods: {
    cancel() { this.$router.replace({ name: 'profile' }); },
    edit() { this.$router.replace({ name: 'profile', params: { tag: 'edit' }}); },
    async save() {
      if(!(this.model.name || '').trim()) { return this.$toastr.e('Name required.'); }
      if((this.pass.new || this.pass.old) && this.pass.new != this.pass.old) { return this.$toastr.e('Password and Retype Password doesn\' match.'); }
      if(this.pass.old) { this.model.password = forge.sha256.create().update(this.pass.old).digest().toHex(); }

      try {
        await api.profile.update(this.model);
        this.$toastr.s('Updated'); this.$emit('refresh');
        this.cancel();
        this.lock = true;
      } catch(e) { this.$toastr.e(e.data); }
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] profile', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; this.model = { is_use: true, is_active: true }; return; }
      else { this.add = false; }
      this.lock = (tag !== 'edit');
      try { this.model = Object.assign({}, this.model, await api.profile.get()); }
      catch(e) { this.$toastr.e(e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() { this.get(this.$route.params); },
}
</script>
